import React from 'react'
import "../failure.css"
function Failure() {
    return (
        <>
            <section className="c-container">
                <div className="o-circle c-container__circle o-circle__sign--failure">
                    <div className="o-circle__sign"></div>
                </div>

            </section>

        </>
    )
}

export default Failure
